export default "__VITE_ASSET__AOZUEp6d__"